import React from "react";
import { BiBulb, BiTargetLock } from "react-icons/bi";

const Idea = () => {
  return (
    <>
      <section
        id="idea"
        className="relative py-20 md:py-32 bg-blue overflow-hidden"
      >
              <div className="absolute z-10 bottom-0 rotate-180 left-0 w-full overflow-hidden leading-none">
        <svg
          className="relative block w-full h-12"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            className="fill-dark-blue"
          ></path>
        </svg>
      </div>
        <div className="container mx-auto px-6 md:px-12 relative z-10">
          <div className="max-w-6xl mx-auto">
            {/* Section Title */}
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-semibold text-white mb-4 uppercase tracking-wide">
                فكرة الهاكاثون
              </h2>
              <div className="w-24 h-1 bg-yellow mx-auto rounded-full"></div>
            </div>

            {/* Main Content */}
            <div className="grid md:grid-cols-2 gap-8 items-center mb-12">
              {/* Left: Main Message */}
              <div className="bg-dark-blue/50 hover:scale-105 rounded-3xl p-8 md:p-10 transition-all ">
                <div className="text-6xl mb-6 text-yellow">
                  <BiBulb />
                </div>
                <h3 className="text-xl md:text-2xl font-semibold text-white mb-6 text-start">
                  ابنِ أداة تسهّل البرمجة أو دراستها للمطور العربي
                </h3>
                <p className="text-white/90 text-lg leading-relaxed text-start">
                  سواء كانت مكتبة، CLI Tool، محرر، أو منصة مساعدة في فهم الأكواد
                  — كل ما يسهّل حياة المبرمج العربي، يفتح بابًا جديدًا في عالم
                  التقنية بلغتنا.
                </p>
              </div>

              {/* Right: Goal */}
              <div className="bg-dark-blue/50 hover:scale-105 transition-all  rounded-3xl p-8 md:p-10">
                <div className="text-6xl mb-6 text-yellow">
                  <BiTargetLock />
                </div>
                <h3 className="text-xl md:text-2xl font-semibold text-white mb-6 text-start">
                  هدفنا
                </h3>
                <p className="text-white/90 text-lg leading-relaxed text-start">
                  دعم المطورين لبناء أدوات عربية مفتوحة المصدر، تكون نواة لمجتمع
                  برمجي عربي أقوى وأكثر استقلالًا.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Idea;
